import classes from './ServiceItem.module.css'

function ServiceItem(props) {
  const isOdd = props.id % 2 === 1;

  return (
    <div className={isOdd ? classes.serviceCard : classes.serviceCardReverse}>
      <div
        className={classes.imagePane}
        style={{ backgroundImage: `url(${props.image})` }}
      />
      <div className={classes.desc}>
        <p className={classes.title}>{props.title}</p>
        <p>{props.description}</p>
        {props.description1 && props.description1 !== "" && (
          <p className={classes.tagline}>{props.description1}</p>
        )}
      </div>
    </div>
  );
}

export default ServiceItem;
